import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

const SCOPES = ['common', 'auth', 'landing', 'dashboard', 'admin', 'feedback', 'legal'] as const;

@Injectable({ providedIn: 'root' })
export class HttpTranslocoLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return forkJoin(
      SCOPES.map((scope) => this.http.get<Translation>(`/assets/i18n/${lang}/${scope}.json`)),
    ).pipe(
      map((parts) =>
        parts.reduce<Translation>((merged, part, idx) => {
          merged[SCOPES[idx]] = part;
          return merged;
        }, {} as Translation),
      ),
    );
  }
}
